import {Deserializable} from '../deserializable';
import {Staffs} from '../staff/staffs';


export  class ThongBaoStaff implements Deserializable
{
  public  id: number;
  public  thongBaoID: number;
  public  yKien: string;
  public  staffID: number;
  public  soLanDoc: number;
  public  thoiGianXemLanDau: string;
  public  thoiGianXemLanCuoi: string;
  public  nguoiYKien: Staffs;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.nguoiYKien= input.nguoiYKien!= null? new Staffs().deserialize(input.nguoiYKien): null;
    return this;
  }
}
